import React, { Children } from 'react';
import { CommonFieldLayout, InputAndValidationWrapper, LabelWrapper, } from './common';
/**
 * FieldLayout is component that positions properly common form field elements:
 * label, input control and validation message. This is layout component only.
 * In order to build a form field you need to place <em>Label</em> inside label region,
 * <em>ValidationMessage</em> inside validation region and any input control as a child.
 */
export const FieldLayout = ({ label, validation, children, ...rest }) => (React.createElement(CommonFieldLayout, { ...rest },
    React.createElement(LabelWrapper, null, label),
    React.createElement(InputAndValidationWrapper, null,
        // React.Children.only accepts exactly ONE ReactElement, string for this API
        // is not ReactElement so we need to check it by ourself
        typeof children === 'string' ? children : Children.only(children),
        validation)));
//# sourceMappingURL=FieldLayout.js.map